import { Map } from "maplibre-gl";
import { parseCookies } from "nookies";
import React, {
  createContext,
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import {
  retrieveALLApplicationAccesses,
  retrieveUserProfile,
} from "../apis/account";
import { getConfiguration } from "../apis/configurations";

import { IConfig, IsignUpInput } from "../types/auth";

import { Action } from "./websocketContext";
import nookies from "nookies";
import { useRouter } from "next/router";
import { themeStorage } from "../theme/themecontext";
import { wallet_provider_key } from "../config";
import { checkScope } from "../apis/auth";
import { REFRESH_TOKEN, postRefreshToken } from "../va-package/apis";

interface IMainContext {
  userInfo: IsignUpInput | undefined;
  setuserInfo: Function;
  systemConfig: IConfig | undefined;
  dispatchSystemConfig: (action: Action) => void;
  map: Map | undefined;
  theme: any | undefined;
  setMap: Function;
  dispatchTheme: (action: Action) => void;
  resetContext: () => void;
}

const initalState: IMainContext = {
  userInfo: undefined,
  setuserInfo: () => undefined,
  systemConfig: undefined,
  dispatchSystemConfig: () => {},
  map: undefined,
  setMap: () => {},
  theme: undefined,
  dispatchTheme: () => {},
  resetContext: () => {},
};

const reducerSystemConfig = (state: any, action: Action) => {
  switch (action.type) {
    case "SET_CONFIG":
      return action.payload;
    default:
      return state;
  }
};

export const setMainConfig = (config: IConfig | undefined) => ({
  type: "SET_CONFIG",
  payload: config,
});

const reducerTheme = (state: any, action: Action) => {
  switch (action.type) {
    case "SET_THEME":
      return action.payload;
    default:
      return state;
  }
};

export const setMainTheme = (thm: any | undefined) => ({
  type: "SET_THEME",
  payload: thm,
});

export const MainContext = createContext<IMainContext>(initalState);
export const MainContextProvider = (props: any) => {
  const [userInfo, setuserInfo] = useState<IsignUpInput | undefined>(
    initalState.userInfo
  );

  const [systemConfig, dispatchSystemConfig] = useReducer(
    reducerSystemConfig,
    initalState.systemConfig
  );

  const [map, setMap] = useState<Map | undefined>(initalState.map);

  const [theme, dispatchTheme] = useReducer(reducerTheme, initalState.theme);

  const initFirst = useRef(true);

  const resetContext = () => {
    setMap(undefined);

    nookies.destroy(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
      path: "/",
    });
    nookies.destroy(
      null,
      process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
      {
        path: "/",
      }
    );

    nookies.destroy(null, wallet_provider_key, {
      path: "/",
    });

    setuserInfo(undefined);
  };

  const mainContextValue = {
    userInfo,
    setuserInfo,
    systemConfig,
    dispatchSystemConfig,
    map,
    setMap,
    theme,
    dispatchTheme,
    resetContext,
  };

  const { replace, pathname } = useRouter();

  const initUserinfo = useCallback(async () => {
    const allCookies = parseCookies();
    const token =
      allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string];

    if (token) {
      const check: any = await checkScope(token);

      if (check.code === 200) {
        const Profile: any = await retrieveUserProfile(check?.accessToken);

        const allScopes: any = await retrieveALLApplicationAccesses(
          Profile?.accessToken
        );

        const mgntScopes =
          allScopes && allScopes.result
            ? allScopes.result.message
              ? []
              : allScopes.result.reduce((rs: any[], cur: any) => {
                  return cur.application.source === "/management"
                    ? [...rs, ...cur.scopes]
                    : rs;
                }, [])
            : [];
        const scopes =
          allScopes && allScopes.result
            ? allScopes.result.message
              ? []
              : allScopes.result.reduce((rs: any[], cur: any) => {
                  return [...rs, ...cur.scopes];
                }, [])
            : [];
        const appIds =
          allScopes && allScopes.result
            ? allScopes.result.message
              ? []
              : allScopes.result.reduce((rs: any[], cur: any) => {
                  return [...rs, cur?.application?.id];
                }, [])
            : [];

        if (Profile.code === 200) {
          const data = Profile?.result;
          const allCookie = parseCookies();
          const getConfig =
            data?.role === "root"
              ? await getConfiguration(
                  undefined,
                  allCookie[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string]
                )
              : await getConfiguration();
          if (getConfig.code) {
          } else {
            dispatchSystemConfig(setMainConfig(getConfig));
            dispatchTheme(
              setMainTheme(
                getConfig?.preferences?.themeConfig
                  ? {
                      ...getConfig?.preferences?.themeConfig,
                      defaultTheme: allCookie[themeStorage]
                        ? allCookie[themeStorage]
                        : getConfig?.preferences?.themeConfig[themeStorage]
                        ? getConfig?.preferences?.themeConfig[themeStorage]
                        : "light",
                    }
                  : undefined
              )
            );
          }
          if (data.identityProvider) {
            setuserInfo({
              ...userInfo,
              id: data.id,
              username: data.username,
              email: data.email,
              firstName: data.firstName,
              lastName: data.lastName,
              organization: data?.extension?.organization
                ? data.extension.organization
                : "",
              role: data.role,
              avatar: data.avatar ? data.avatar : "",
              identityProvider: data.identityProvider,
              mgntScopes,
              scopes,
              appIds,
              extension: data?.extension ?? null,
            });
          } else {
            setuserInfo({
              ...userInfo,
              id: data.id,
              username: data.username,
              email: data.email,
              firstName: data.firstName,
              lastName: data.lastName,
              organization: data?.extension?.organization
                ? data.extension.organization
                : "",
              role: data.role,
              avatar: data.avatar ? data.avatar : "",
              mgntScopes,
              scopes,
              appIds,
              extension: data?.extension ?? null,
            });
          }
        } else {
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(
            null,
            process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
            {
              path: "/",
            }
          );
          nookies.destroy(null, wallet_provider_key, {
            path: "/",
          });
          setuserInfo(undefined);
          replace(`/`);
        }
      }
    } else if (token === undefined && allCookies[REFRESH_TOKEN]) {
      const newToken = await postRefreshToken(allCookies[REFRESH_TOKEN]);

      const check: any = await checkScope(newToken?.result?.accessToken);

      if (newToken?.status === 200) {
        if (check.code === 200) {
          const Profile: any = await retrieveUserProfile(check?.accessToken);
          const allScopes: any = await retrieveALLApplicationAccesses(
            Profile?.accessToken
          );
          const mgntScopes =
            allScopes && allScopes.result
              ? allScopes.result.message
                ? []
                : allScopes.result.reduce((rs: any[], cur: any) => {
                    return cur.application.source === "/management"
                      ? [...rs, ...cur.scopes]
                      : rs;
                  }, [])
              : [];
          const scopes =
            allScopes && allScopes.result
              ? allScopes.result.message
                ? []
                : allScopes.result.reduce((rs: any[], cur: any) => {
                    return [...rs, ...cur.scopes];
                  }, [])
              : [];
          const appIds =
            allScopes && allScopes.result
              ? allScopes.result.message
                ? []
                : allScopes.result.reduce((rs: any[], cur: any) => {
                    return [...rs, cur?.application?.id];
                  }, [])
              : [];

          if (Profile.code === 200) {
            const data = Profile?.result;
            const allCookie = parseCookies();
            const getConfig =
              data?.role === "root"
                ? await getConfiguration(
                    undefined,
                    allCookie[
                      process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string
                    ]
                  )
                : await getConfiguration();
            if (getConfig.code) {
            } else {
              dispatchSystemConfig(setMainConfig(getConfig));
              dispatchTheme(
                setMainTheme(
                  getConfig?.preferences?.themeConfig
                    ? {
                        ...getConfig?.preferences?.themeConfig,
                        defaultTheme: allCookie[themeStorage]
                          ? allCookie[themeStorage]
                          : getConfig?.preferences?.themeConfig[themeStorage]
                          ? getConfig?.preferences?.themeConfig[themeStorage]
                          : "light",
                      }
                    : undefined
                )
              );
            }
            if (data.identityProvider) {
              setuserInfo({
                ...userInfo,
                id: data.id,
                username: data.username,
                email: data.email,
                firstName: data.firstName,
                lastName: data.lastName,
                organization: data?.extension?.organization
                  ? data.extension.organization
                  : "",
                role: data.role,
                avatar: data.avatar ? data.avatar : "",
                identityProvider: data.identityProvider,
                mgntScopes,
                scopes,
                appIds,
                extension: data?.extension ?? null,
              });
            } else {
              setuserInfo({
                ...userInfo,
                id: data.id,
                username: data.username,
                email: data.email,
                firstName: data.firstName,
                lastName: data.lastName,
                organization: data?.extension?.organization
                  ? data.extension.organization
                  : "",
                role: data.role,
                avatar: data.avatar ? data.avatar : "",
                mgntScopes,
                scopes,
                appIds,
                extension: data?.extension ?? null,
              });
            }
          } else {
            nookies.destroy(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              {
                path: "/",
              }
            );
            nookies.destroy(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              {
                path: "/",
              }
            );
            nookies.destroy(null, wallet_provider_key, {
              path: "/",
            });
            setuserInfo(undefined);
            replace(`/`);
          }
        }
      } else {
        nookies.destroy(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
          path: "/",
        });
        nookies.destroy(
          null,
          process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
          {
            path: "/",
          }
        );
        nookies.destroy(null, wallet_provider_key, {
          path: "/",
        });
        setuserInfo(undefined);
        setTimeout(() => {
          replace(`/`);
        }, 800);
      }
    } else {
      nookies.destroy(null, process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any, {
        path: "/",
      });
      nookies.destroy(
        null,
        process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
        {
          path: "/",
        }
      );

      nookies.destroy(null, wallet_provider_key, {
        path: "/",
      });

      setuserInfo(undefined);

      if (
        pathname.includes("verify-email") ||
        pathname.includes("email-confirm") ||
        pathname.includes("send-email") ||
        pathname.includes("signin") ||
        pathname.includes("signup") ||
        pathname.includes("forgot-password") ||
        pathname.includes("reset-password") ||
        pathname.includes("redirect") ||
        pathname.includes("terms") ||
        pathname.includes("privacy") ||
        pathname.includes("authentication")
      ) {
      } else {
        setTimeout(() => {
          replace(`/`);
        }, 800);
      }

      const getConfig = await getConfiguration();

      if (getConfig.code) {
      } else {
        const allCookie = parseCookies();

        dispatchSystemConfig(setMainConfig(getConfig));

        dispatchTheme(
          setMainTheme(
            getConfig?.preferences?.themeConfig
              ? {
                  ...getConfig?.preferences?.themeConfig,
                  defaultTheme: allCookie[themeStorage]
                    ? allCookie[themeStorage]
                    : getConfig?.preferences?.themeConfig[themeStorage]
                    ? getConfig?.preferences?.themeConfig[themeStorage]
                    : "light",
                }
              : undefined
          )
        );
      }
    }
  }, []);

  useEffect(() => {
    if (initFirst.current) {
      console.log("first init main data");
      initFirst.current = false;
      initUserinfo();
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (userInfo?.id && !userInfo?.scopes) {
      initUserinfo();
      console.log("get new data");
    }
    return () => {};
  }, [userInfo?.id]);

  return (
    <MainContext.Provider value={mainContextValue}>
      {props.children}
    </MainContext.Provider>
  );
};

export const MainContextConsumer = MainContext.Consumer;
